import { render, staticRenderFns } from "./RegionMapView.vue?vue&type=template&id=68be4212&scoped=true&"
import script from "./RegionMapView.vue?vue&type=script&lang=js&"
export * from "./RegionMapView.vue?vue&type=script&lang=js&"
import style0 from "./RegionMapView.vue?vue&type=style&index=0&id=68be4212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be4212",
  null
  
)

export default component.exports